import { render, staticRenderFns } from "./CombinedResultReport.vue?vue&type=template&id=61d2df36"
import script from "./CombinedResultReport.vue?vue&type=script&lang=js"
export * from "./CombinedResultReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports